export default {
      id: "i-service-stock-usage",
      viewBox: "0 0 139 139",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-stock",
      toString: function () {
        return this.url;
      }
    }